import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import StepperComponent from "components/blocks/stepper/Stepper";
import KeyType from "../common/KeyType";
import { ButtonWrapper } from "styles/ModalCommonStyled";
import BigButton from "components/atoms/buttons/BigButton";
import GenerateKeyInfo from "./component/GenerateKeyInfo";
import ConfirmKeyInfo from "./component/ConfirmKeyInfo";
import { ReactComponent as CART_ADD_ICON } from "assets/icons/cart_add.svg";
import SuccessKey from "./component/SuccessKey";
import {
  KeyCost,
  KeyInfo,
  SUBSCRIPTION_TYPE,
} from "api/interfaces/subscription.interface";
import {
  ProfileAccountInfo,
} from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { useAppSelector } from "redux/hooks";

type Props = {
  generateKeyData: KeyInfo;
  cost: KeyCost;
  page: number;
  successKeyList: string[];
  isSuccessKey: boolean;
  validateMsg: { [key: string]: string };
  isDisabledNext: Record<string, boolean>;
  generateValidateMsg: Record<string, string>;
  onModal: () => void;
  onChangePage: (name: string, index?: number) => void;
  onChangeKeyData: (name: string, value: any) => void;
  onMutateGenerateKey: () => void;
};
const steps = [
  {
    label: "Select Subscription Type",
  },
  {
    label: "Subscription Info",
  },
  {
    label: "Confirm Subscription Info",
  },
];

export default function GenerateKeyModalPresenter(props: Props): JSX.Element {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  return (
    <BigPopupTemplate title="Generate Subscription Key" onModal={props.onModal}>
      {props.isSuccessKey ? (
        <SuccessKey successKeyList={props.successKeyList} />
      ) : (
        <>
          <StepperComponent
            activeStep={props.page}
            steps={steps}
            onClick={props.onChangePage}
            data-testid="subscription-modal-generate-key-stepper-component-change-page"
          />

          {props.page === 0 && (
            <KeyType
              keyType={props.generateKeyData.keyType}
              onChangeType={(value: SUBSCRIPTION_TYPE) =>
                props.onChangeKeyData("keyType", value)
              }
            />
          )}

          {props.page === 1 && (
            <GenerateKeyInfo
              keyInfo={props.generateKeyData}
              cost={props.cost}
              onChangeKeyData={props.onChangeKeyData}
              validateMsg={{
                ...props.generateValidateMsg,
                generateKeyInfo: props.validateMsg.generateKeyInfo,
              }}
            />
          )}

          {props.page === 2 && (
            <ConfirmKeyInfo
              keyInfo={props.generateKeyData}
              cost={props.cost}
              validateMsg={props.validateMsg.confirmKeyInfo}
            />
          )}
        </>
      )}

      <ButtonWrapper>
        {props.isSuccessKey ? (
          <BigButton
            label={"Close"}
            buttonType={"primary"}
            onClickBtn={() => {
              props.onModal();
            }}
            data-testid="subscription-modal-generate-key-button-modal"
          />
        ) : (
          <>
            <BigButton
              label={props.page === 0 ? "Next" : "Previous"}
              buttonType={
                props.isDisabledNext.type || props.page !== 0
                  ? "cancel"
                  : "primary"
              }
              onClickBtn={() => {
                if (props.page === 0) {
                  props.onChangePage("next");
                } else {
                  props.onChangePage("previous");
                }
              }}
              disabled={props.isDisabledNext.type}
              data-testid="subscription-modal-generate-key-button-change-page"
            />

            {props.page !== 0 && (
              <BigButton
                iconComponent={
                  props.page === 2 &&
                  selectedAccount.accountLevel !== LEVEL_TYPE.DW ? (
                    <CART_ADD_ICON />
                  ) : undefined
                }
                label={
                  props.page === 2
                    ? selectedAccount.accountLevel !== LEVEL_TYPE.DW
                      ? "Checkout"
                      : "Generate Keys"
                    : "Next"
                }
                buttonType={
                  props.page !== 2 && props.isDisabledNext.info
                    ? "cancel"
                    : undefined
                }
                onClickBtn={() => {
                  if (props.page === 2) {
                    props.onMutateGenerateKey();
                    // 결제창으로 넘어가고 결제성공 후 true 로
                  } else {
                    props.onChangePage("next");
                  }
                }}
                data-testid="subscription-modal-generate-key-button-mutate-generate-key"
              />
            )}
          </>
        )}
      </ButtonWrapper>
    </BigPopupTemplate>
  );
}
